import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
import { DumbbellIcon } from 'lucide-react';
interface BruteScoreEntryProps {
  onNext: (score: number) => void;
  initialScore?: number;
}
export function BruteScoreEntry({
  onNext,
  initialScore
}: BruteScoreEntryProps) {
  const [score, setScore] = useState(initialScore ? initialScore.toString() : '');
  const [unit, setUnit] = useState<'lbs' | 'kg'>('lbs');
  const [error, setError] = useState('');
  const handleChange = (val: string) => {
    setError('');
    if (/^\d*\.?\d*$/.test(val)) {
      setScore(val);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const numScore = parseFloat(score);
    if (isNaN(numScore) || numScore <= 0) {
      setError('Please enter a valid score.');
      return;
    }
    if (!score.includes('.')) {
      setError('Must include one decimal place — e.g. 47.2');
      return;
    }
    const decimalPart = score.split('.')[1];
    if (!decimalPart || decimalPart.length === 0) {
      setError('Must include one decimal place — e.g. 47.2');
      return;
    }
    const finalScore = unit === 'kg' ? numScore * 2.20462 : numScore;
    onNext(Math.round(finalScore * 10) / 10);
  };
  return <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-zinc-950 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-orange-900/20 via-zinc-950 to-zinc-950" data-id="element-22">
      <div className="mb-8 text-center" data-id="element-23">
        <DumbbellIcon className="w-16 h-16 text-orange-500 mx-auto mb-4" data-id="element-24" />
        <h1 className="text-5xl md:text-7xl font-black text-white tracking-tighter uppercase italic" style={{
        fontFamily: 'Impact, sans-serif'
      }} data-id="element-25">
          BRUTE <span className="text-orange-500" data-id="element-26">SCORE</span>
        </h1>
      </div>

      <Card variant="brawn" className="w-full max-w-lg" data-id="element-27">
        <p className="text-orange-200 text-center mb-6 text-lg" data-id="element-28">
          Squeeze the dynamometer as hard as you can. Enter your peak reading
          below.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-29">
          <div className="flex gap-4 items-start" data-id="element-30">
            <div className="flex-1" data-id="element-31">
              <input type="text" inputMode="decimal" value={score} onChange={e => handleChange(e.target.value)} placeholder="47.2" autoFocus className="w-full bg-black/50 border-2 border-orange-900/50 focus:border-orange-500 rounded-sm px-4 py-5 text-center text-5xl font-black text-white placeholder-white/20 focus:outline-none transition-colors" data-id="element-32" />
              {error && <p className="text-red-400 text-sm font-mono mt-2 text-center" data-id="element-33">
                  {error}
                </p>}
            </div>
            <div className="flex bg-zinc-900 rounded-sm border border-orange-900/30 p-1 mt-1" data-id="element-34">
              <button type="button" onClick={() => setUnit('lbs')} className={`px-4 py-3 rounded-sm font-bold transition-colors ${unit === 'lbs' ? 'bg-orange-600 text-white' : 'text-gray-500 hover:text-white'}`} data-id="element-35">
                LBS
              </button>
              <button type="button" onClick={() => setUnit('kg')} className={`px-4 py-3 rounded-sm font-bold transition-colors ${unit === 'kg' ? 'bg-orange-600 text-white' : 'text-gray-500 hover:text-white'}`} data-id="element-36">
                KG
              </button>
            </div>
          </div>

          <Button type="submit" variant="brawn" className="w-full" size="lg" disabled={!score} data-id="element-37">
            RECORD STRENGTH
          </Button>
        </form>
      </Card>
    </div>;
}